<template>
  <div class="b-product-modal" align="right">
    <b-modal id="preview-capsule" size="lg" :lazy="true" hide-footer>
      <b-row>
        <b-col offset-md="1" md="10">
          <CapsuleContent :capsule="capsule" :stitch-mode="false" />
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import CapsuleContent from "@/components/capsule/CapsuleContentOld";

export default {
  components: {
    CapsuleContent
  },

  props: {
    capsule: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss">
@import "~@/styles/_colour-palette.scss";
@import "~@/styles/_breakpoints.scss";

.modal-lg {
  max-width: 80% !important;
}

.modal-header {
  border-bottom: 0;
  padding-bottom: 0;
}

.modal-content {
  background-color: $grey8;
  border-radius: 4px;
  min-height: 600px !important;
}

.card-header {
  letter-spacing: 1px;
  color: $primary-blue;
  font-weight: 100;
  font-size: 12px;
  transition: all 0.2s ease-in;

  &:hover {
    font-weight: 600;
    color: white;
    background-color: $primary-blue;
  }
}

.b-product-modal {
  text-align: center;

  @include for-tablet-portrait-up {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/capsuleBuilder/modals/OutfitsModal.vue